import React, {createContext} from 'react';
import PropTypes from 'prop-types';
import noop from '../utils/noop';
import useAccountBalances from '../hooks/useAccountBalances';

const Context = createContext({
  accountBalances: null,
  isFetching: false,
  error: null,
  fetchAccountBalances: noop,
});

export default Context;

export const AccountBalancesContextProvider = ({children}) => {
  const value = useAccountBalances();

  return <Context.Provider value={value}>{children}</Context.Provider>;
};

AccountBalancesContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
